document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('[data-size-guide-open]');
  var overlay = document.querySelector('[data-size-guide-overlay]');
  var closeBtn = document.querySelector('[data-size-guide-close]');
  if (!trigger || !overlay) return;
  function openModal() {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }
  trigger.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeModal();
  });
});